import styled from 'styled-components';

export const IconCardFeature = styled.img`
    height: 7rem;
`;

export const BodyCard = styled.div`
    min-height: 7rem;
`;